import { useMemo } from "react"

const useClassesTableColumns = () => {
    const columns = useMemo(
        () => [
            {
                accessorKey: 'name',
                header: "כיתה",
            }
        ], []
    )

    return columns
}

export default useClassesTableColumns